module.exports = __webpack_public_path__ + "img/ic2_hot.03a40437.png";